package com.trevorwiebe.timesheet.punch.domain.usecases

import com.trevorwiebe.timesheet.core.domain.Util.between
import com.trevorwiebe.timesheet.core.domain.model.Rate
import com.trevorwiebe.timesheet.punch.presentation.uiUtils.UiPunch
import kotlin.time.Duration

class AddUpHours {

    operator fun invoke(
        punchList: List<UiPunch>,
        rateList: List<Rate>,
    ): List<Pair<String, Double>> {
        val hoursMap = getHoursWorkedForDay(punchList, rateList)
        return hoursMap
    }

    private fun getHoursWorkedForDay(
        uiPunchList: List<UiPunch>,
        rateList: List<Rate>,
    ): List<Pair<String, Double>> {
        if (uiPunchList.isEmpty()) return emptyList()

        val totalHours = mutableListOf<Pair<String, Double>>()

        rateList.forEach { rate ->
            val ratePunchList = uiPunchList.filter { it.getRate(rateList)?.id == rate.id }

            var rateTotalMinutes = 0L

            ratePunchList.forEach { uiPunch ->
                val punchIn = uiPunch.punchIn
                val punchOut = uiPunch.punchOut ?: return@forEach

                val durationMinutes =
                    Duration.Companion.between(punchIn.dateTime, punchOut.dateTime).inWholeMinutes
                rateTotalMinutes += durationMinutes
            }

            val totalRateHours = (rateTotalMinutes / 60.0)

            if (totalRateHours == 0.0) return@forEach

            val ratePair = Pair("${rate.description} Hours", roundToNearestQuarter(totalRateHours))

            totalHours.add(ratePair)
        }

        return totalHours.sortedBy { it.first }
    }
}

internal fun roundToNearestQuarter(hours: Double): Double {
    val rounded = kotlin.math.round(hours * 4.0) / 4.0
    return if (rounded == rounded.toInt().toDouble()) {
        rounded.toInt().toDouble()
    } else {
        rounded
    }
}